import React from 'react';
import PropTypes from 'prop-types';

const PropertyEditor = ({
    selectedLayer,
    color,
    weight,
    opacity,
    fillColor,
    fillOpacity,
    updateSelectedLayerStyle
}) => {
    if (!selectedLayer) return null;

    return (
        <div style={{
            position: 'absolute',
            top: 10,
            right: 40,
            backgroundColor: 'white',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0px 0px 6px rgba(0,0,0,0.3)',
            zIndex: 1000
        }}>
            <div>
                <label>Title:</label><br />
                <input
                    type="text"
                    value={selectedLayer.feature?.properties?.featureTitle || ''}
                    onChange={(e) => updateSelectedLayerStyle('featureTitle', e.target.value)}
                    placeholder="title"
                />
            </div>
            {selectedLayer.feature.geometry.type !== 'Point' &&
                <div>
                    <div>
                        <label>Stroke Color:</label><br />
                        <input type="color" value={color} onChange={(e) => updateSelectedLayerStyle('color', e.target.value)} />
                    </div>
                    <div>
                        <label>Stroke Width:</label><br />
                        <input type="number" value={weight} onChange={(e) => updateSelectedLayerStyle('weight', e.target.value)} min="1" max="20" />
                    </div>
                    <div>
                        <label>Stroke Opacity:</label><br />
                        <input type="range" min="0" max="1" step="0.1" value={opacity} onChange={(e) => updateSelectedLayerStyle('opacity', e.target.value)} />
                    </div>
                    <div>
                        <label>Fill Color:</label><br />
                        <input type="color" value={fillColor} onChange={(e) => updateSelectedLayerStyle('fillColor', e.target.value)} />
                    </div>
                    <div>
                        <label>Fill Opacity:</label><br />
                        <input type="range" min="0" max="1" step="0.1" value={fillOpacity} onChange={(e) => updateSelectedLayerStyle('fillOpacity', e.target.value)} />
                    </div>
                </div>
            }
        </div>
    );
};

PropertyEditor.propTypes = {
    selectedLayer: PropTypes.object,
    color: PropTypes.string.isRequired,
    weight: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
    opacity: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
    fillColor: PropTypes.string.isRequired,
    fillOpacity: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
    updateSelectedLayerStyle: PropTypes.func.isRequired
};

export default PropertyEditor;